import styled from 'styled-components'

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: ${({ theme }) => theme.space['7XL']};
  row-gap: ${({ theme }) => theme.space['6XL']};
`

export { ModalContent }
